const images = {
  logo_default: "/img/logo/logo_hays_recruiting.jpg",
  logo_wide: "/img/logo/wide_logo_hays_recruiting.jpg",
  maintenance_image: "/img/maintenace-site-web.png",
  maintenance_image_banner: "/img/banner.png",
  maintenance_image_banner_mobile: "/img/cut-banner.png",
  emailTemplateOverviewContent: "/img/email_overview_content.jpg",
  emailTemplateOverviewComment: "/img/email_overview_comment.jpg",
  invoicesEmailTemplateOverviewContent: "/img/invoices_email_overview_content.jpg",
  timesheetDataEmailTemplateOverviewContent: "/img/timesheet_data_email_overview_content.jpg",
  invoicesImportReportOverviewContent: "/img/invoices_import_report_overview.jpg",
  timesheetsImportReportOverviewContent: "/img/timesheets_import_report_overview.jpg",
}
export default images;
